function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.81 26.75v23.72a9.31 9.31 0 009.31 9.31h39.81a9.31 9.31 0 009.31-9.31V26.75",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5,
  d: "M19.13 26.52l12.89 12.89 12.9-12.89M32.02 2.72v36.69"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZG93bmxvYWQ8L3RpdGxlPjxwYXRoIGQ9Ik0yLjgxLDI2Ljc1VjUwLjQ3YTkuMzEsOS4zMSwwLDAsMCw5LjMxLDkuMzFINTEuOTNhOS4zMSw5LjMxLDAsMCwwLDkuMzEtOS4zMVYyNi43NSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1Ii8+PHBvbHlsaW5lIHBvaW50cz0iMTkuMTMgMjYuNTIgMzIuMDIgMzkuNDEgNDQuOTIgMjYuNTIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNSIvPjxsaW5lIHgxPSIzMi4wMiIgeTE9IjIuNzIiIHgyPSIzMi4wMiIgeTI9IjM5LjQxIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjUiLz48L3N2Zz4=";
export { SvgDownload as ReactComponent };